<!-- 选择招生来源 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="comeFroms" type="comeFroms" clearable/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-招生来源选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '招生来源：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const comeFroms = useQuery('comeFroms', props.value);

    return {
      comeFroms,
    };
  },
};
</script>
